import { ParamsWithPagination } from '@/types/api';

import { SupportFilters } from '../types';

export const supportsQueryKeys = {
  all: ['supports'] as const,
  lists: () => [...supportsQueryKeys.all, 'list'] as const,
  list: (params?: ParamsWithPagination<SupportFilters>) =>
    [...supportsQueryKeys.lists(), params] as const,
};
